import React, { useState, useEffect, useContext,  useMemo } from "react";
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import LoaderAnimation from "pages/LoaderAnimation";
import ComplianceReport from "components/Content/Table/ComplianceReport";

export default function CompleteCompliance ({isActive, complianceId, isComplianceApproved, setIsComplianceApproved }) {
    const { error } = useContext(PrivateRoutesContext);

    const [isComplianceReportVisible, setIsComplianceReportVisible] = useState(false);
    const [isLoadingComplianceReport, setIsLoadingComplianceReport] = useState(false);
    const [complianceReportData, setComplianceReportData] = useState(null);

    const loadComplianceReport = () => {
        if (!isLoadingComplianceReport) {
            setIsLoadingComplianceReport(true);

            apiGet(apiUrls.getComplianceReport(complianceId)).then(response => {
                setIsComplianceReportVisible(true);
                setComplianceReportData(response.data);
            }).catch(response => {
                console.log(response);
                error.setTitle("An Error Occurred");
                error.setText("An Error occurred loading compliance report.");
                error.setDoShowError(true);
            }).finally(() => {
                setIsLoadingComplianceReport(false);
            });
        }
    }

    return (
        <Box>
            {isComplianceReportVisible ?
                <ComplianceReport reportData={complianceReportData} />
            :
            <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 3 }}>
                <LoadingButton
                    onClick={() => loadComplianceReport()}
                    color="primary"
                    variant="outlined"
                    disabled={isLoadingComplianceReport}
                    loadingPosition="center"
                    loading={isLoadingComplianceReport}
                >
                    View Compliance Report
                </LoadingButton>
            </Box>}
            <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 3 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            disabled={!isComplianceReportVisible}
                            checked={isComplianceApproved}
                            onChange={() => setIsComplianceApproved((prevState) => !prevState)}
                        />}
                    label="I acknowledge the generated compliance report is accurate and complete"
                />
            </Box>
        </Box>
    )
}